import { useState, useEffect, useCallback } from 'react';
import { useStore } from './useStore';
import { scrollToElement } from '../utils';

const useProgress = () => {
  const [state, dispatch] = useStore();
  const { step, stepped, dateTimeConfirmed } = state;
  const [progress, setProgress] = useState(step);
  // const section = sessionStorage.getItem('section');

  useEffect(() => {
    // console.log('progress', progress);
    dispatch('RESET_MESSAGES');
    dispatch('SET', {
      step: progress,
      stepped: progress,
      // checkoutStep: 1,
      // checkoutStepped: 1,
    });
  }, [progress]);

  const getStep = () => {
    return step;
  }
  const goBack = () => {
    console.log('goBack');
    setProgress(step - 1);
    sessionStorage.setItem('step', step - 1);
    dispatch('RESET_MESSAGES');
  }
  const goNext = () => {
    setProgress(step + 1);
    console.log('goNext', step);
    sessionStorage.setItem('step', step + 1);
    // setTimeout(() => {
    //   scrollToElement('bookTickets', false, true);
    // }, 1000);
  }
  const goDirect = (num) => {
    // console.log('goDirect');
    setProgress(num);
    sessionStorage.setItem('step', num);
    if (num === 0) {
      dispatch('SET', {
        section: 'studio-tour'
      });
      removeUrlHash();
    // } else if (stepped >= num) {
    //   dispatch('SET', { step: num });
    }
  }
  const setUrlHash = (type) => {
    console.log('TYPE', type);
    // const newHash = window.location.hash.replace(/#.*$/, '#' + type);
    // history.replaceState('', document.title, newHash);
    if (history.replaceState) {
      console.log('replace');
      history.replaceState({}, '', '#' + type);
    } else {
      console.log('else');
      window.location.hash = '#' + type;
    }
  }
  const removeUrlHash = () => {
    const noHashURL = window.location.href.replace(/#.*$/, '');
    window.history.replaceState('', document.title, noHashURL);
  }

  return {
    getStep,
    goBack,
    goNext,
    goDirect,
    setUrlHash
  };
}

export default useProgress;